import { Record } from 'immutable';
import {
  ACTIVATE_NEW_CARD,
  ACTIVATE_VIEW_ENTER,
  CARD_NUMBER_SUBMIT,
  REGISTER_CARD_ATTEMPT,
  SET_STEP,
  SHOP_DETAILS_FAILURE,
  SHOP_DETAILS_SUCCESS,
  SHOP_REJECT,
  TERMS_CONSENT
} from './actions';
import { STEP_CARD_NUMBER, STEP_LANDING } from './constants';

export const InitialState = new Record({
  shopId: '',
  shopName: '',
  city: '',
  step: STEP_LANDING,
  cardNumber: '',
  phoneNumber: '',
  termsAccepted: false
});

export default (state = new InitialState(), action) => {
  const { type } = action;

  switch (type) {
    case SHOP_DETAILS_SUCCESS: {
      const { shopId, shopName, city } = action;
      return state.merge({ shopId, shopName, city });
    }
    case SHOP_DETAILS_FAILURE:
    case SHOP_REJECT: {
      return state.merge({
        shopId: '',
        shopName: '',
        city: ''
      });
    }
    case ACTIVATE_VIEW_ENTER: {
      return state.set('step', STEP_LANDING);
    }
    case SET_STEP: {
      const { step } = action;
      return state.set('step', step);
    }
    case CARD_NUMBER_SUBMIT: {
      const { cardNumber } = action;
      return state.set('cardNumber', cardNumber);
    }
    case REGISTER_CARD_ATTEMPT: {
      const { phoneNumber } = action;
      return state.set('phoneNumber', phoneNumber);
    }
    case ACTIVATE_NEW_CARD: {
      return state.merge({
        step: STEP_CARD_NUMBER,
        cardNumber: '',
        phoneNumber: '',
        termsAccepted: false
      });
    }
    case TERMS_CONSENT: {
      const { accepted } = action;
      return state.set('termsAccepted', accepted);
    }
    default: {
      return state;
    }
  }
};
